module.exports = __webpack_public_path__ + "img/rf_advanced_4.a56d5735.jpg";